import { dayjs } from '@convenia/utils'

export const getDaysSince = (timestamp) => {
  return dayjs().diff(dayjs(timestamp), 'day', true)
}

export const isExpired = (timestamp, maxDays) => {
  return getDaysSince(timestamp) > maxDays
}

export const isVersionCompatible = (savedVersion, currentVersion) => {
  return savedVersion === currentVersion
}

export const isIndexedDBSupported = () => {
  return typeof window !== 'undefined' && 'indexedDB' in window && window.indexedDB != null
}
